module.exports = __webpack_public_path__ + "media/Possibilities to Overcome.e2bff3ab.mp3";